import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3853afd4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tip-concent-msg-box-wrap" }
const _hoisted_2 = { class: "tip-concent-msgbox-title-wrap" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "msgbox-body-wrap" }
const _hoisted_5 = { class: "body-content" }
const _hoisted_6 = { class: "box-content" }
const _hoisted_7 = { class: "d-control" }
const _hoisted_8 = { class: "label" }
const _hoisted_9 = { class: "d-control" }
const _hoisted_10 = { class: "label" }
const _hoisted_11 = { class: "box-content" }
const _hoisted_12 = { class: "dropdown-content" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "check" }, null, -1))
const _hoisted_15 = { class: "btn-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_x = _resolveComponent("icon-x")!
  const _component_n_witch = _resolveComponent("n-witch")!
  const _component_icon_arrow_down = _resolveComponent("icon-arrow-down")!

  return (_openBlock(), _createElementBlock("div", {
    class: "tip-concent-msg-box-root",
    onClick: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)), ["self"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.t('setting.gamesetting')), 1),
        _createElementVNode("div", {
          class: "close-btn",
          onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)), ["prevent"]))
        }, [
          _createVNode(_component_icon_x)
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.t('gamesetting.video')), 1),
              _createVNode(_component_n_witch, {
                modelValue: _ctx.videoIsOn,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.videoIsOn) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.t('gamesetting.sound')), 1),
              _createVNode(_component_n_witch, {
                modelValue: _ctx.soundEffectIsOn,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.soundEffectIsOn) = $event))
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", {
              class: _normalizeClass(["lang-options", [_ctx.lang, { show: _ctx.showLanguageOptions }]]),
              onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (
                                _ctx.showLanguageOptions = !_ctx.showLanguageOptions
                            ), ["self"]))
            }, [
              _createTextVNode(_toDisplayString(_ctx.language) + " ", 1),
              _createVNode(_component_icon_arrow_down),
              _createElementVNode("ul", _hoisted_12, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.langArr, (i) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: i.code,
                    class: _normalizeClass([
                                        { active: i.code === _ctx.lang },
                                        i.code
                                    ]),
                    onClick: ($event: any) => (_ctx.selectLanguage(i.code))
                  }, [
                    _createTextVNode(_toDisplayString(i.name) + " ", 1),
                    _hoisted_14
                  ], 10, _hoisted_13))
                }), 128))
              ])
            ], 2)
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", {
            class: "btn-confirm",
            onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.confirm && _ctx.confirm(...args)), ["prevent"]))
          }, _toDisplayString(_ctx.t('common.confirm')), 1),
          _createElementVNode("div", {
            class: "btn-cancel",
            onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args)), ["prevent"]))
          }, _toDisplayString(_ctx.t('common.cancel')), 1)
        ])
      ])
    ])
  ]))
}